import _define_property from "@swc/helpers/src/_define_property.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Feedback from "@material-ui/icons/Feedback";
import FileCopy from "@material-ui/icons/FileCopy";
import Group from "@material-ui/icons/Group";
import GroupWork from "@material-ui/icons/GroupWork";
import RingVolume from "@material-ui/icons/RingVolume";
import clsx from "clsx";
import AccessPointNetwork from "mdi-material-ui/AccessPointNetwork";
import HeartPulse from "mdi-material-ui/HeartPulse";
import VectorPolyline from "mdi-material-ui/VectorPolyline";
import React from "react";
import { useTranslation } from "react-i18next";
import UserInfo from "../../components/user-info";
import { COMPANIES } from "../../constants";
import * as Feature from "../../features";
import PageLink from "../../page-link";
export var properties = {
    width: 240
};
var DrawerClosedBreakpoint = 2220;
var StickyHeaderBreakpoint = "md";
var useStyles = makeStyles(function(theme) {
    var _obj;
    return {
        drawerPaper: {
            height: "100%",
            position: "relative",
            overflow: "visible",
            width: properties.width,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        drawerPaperClose: (_obj = {}, _define_property(_obj, theme.breakpoints.up(DrawerClosedBreakpoint), {
            width: 72
        }), _define_property(_obj, theme.breakpoints.down(DrawerClosedBreakpoint), {
            position: "absolute",
            width: 0
        }), _obj),
        drawerPaperOpen: _define_property({}, theme.breakpoints.down(StickyHeaderBreakpoint), {
            position: "absolute"
        }),
        minimizePaper: {
            position: "absolute",
            width: 0
        },
        drawerInner: {
            alignItems: "flex-start",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between"
        },
        drawerHeader: Object.assign({
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px"
        }, theme.mixins.toolbar),
        flipIconHorizontal: {
            transform: "scaleX(-1)"
        },
        fullWidth: {
            overflowX: "hidden",
            width: "100%"
        },
        bottomSticky: {
            position: "sticky",
            bottom: 0,
            alignSelf: "flex-end"
        },
        topSticky: {
            position: "sticky",
            top: 0
        }
    };
});
var defaultFeatureMap = {
    group: {},
    line: {},
    peripheral: {},
    userPool: {}
};
var Navigation = function(props) {
    var isNavigationOpen = props.isNavigationOpen, removeNavigation = props.removeNavigation, _features = props.features, features = _features === void 0 ? defaultFeatureMap : _features, companyId = props.companyId, closeNavigation = props.closeNavigation, navigationLinks = props.navigationLinks;
    var ref = _sliced_to_array(useTranslation(), 1), t = ref[0];
    var theme = useTheme();
    var classes = useStyles();
    var matches = useMediaQuery(theme.breakpoints.down(DrawerClosedBreakpoint));
    var onTransitionEnd = function() {
        return typeof Event !== "function" ? Function.prototype : function() {
            return window.dispatchEvent(new Event("resize"));
        };
    };
    var closeWhileSmall = matches ? closeNavigation : undefined;
    var administration = "";
    var scheduledReports = "";
    if (Feature.inAnyUserPool(features)([
        "IAM.Role",
        "IAM.Group",
        "IAM.User"
    ], "M")) {
        administration = /*#__PURE__*/ React.createElement(PageLink, {
            href: "/administration",
            icon: /*#__PURE__*/ React.createElement(Group, null),
            onClick: closeWhileSmall,
            title: t([
                "shared:administration"
            ], {
                defaultValue: "Administration"
            })
        });
    }
    var labelLines = t([
        "shared:lines"
    ], {
        defaultValue: "Lines"
    });
    var labelSensors = t([
        "shared:sensors"
    ], {
        defaultValue: "Sensors"
    });
    var labelConsolidatedLines = t([
        "shared:consolidatedLines"
    ], {
        defaultValue: "Consolidated lines"
    });
    var labelMaintenance = t([
        "shared:maintenance"
    ], {
        defaultValue: "Andon"
    });
    var labelScheduledReports = t([
        "shared:scheduledReports"
    ], {
        defaultValue: "Scheduled reports"
    });
    var labelCockpit = t([
        "shared:cockpit"
    ], {
        defaultValue: "Cockpit"
    });
    var labelLogout = t([
        "shared:logout"
    ], {
        defaultValue: "Logout"
    });
    var labelFeedback = t([
        "shared:feedback"
    ], {
        defaultValue: "Feedback"
    });
    var cockpit = "";
    var cockpitAvailable = [
        COMPANIES.BLACKBIRD,
        COMPANIES.BLACKBIRD_STAGING,
        COMPANIES.DITSCH
    ].some(function(cockpitPool) {
        return cockpitPool === companyId;
    });
    if (cockpitAvailable) {
        cockpit = /*#__PURE__*/ React.createElement(PageLink, {
            href: "/cockpit?id=root",
            icon: /*#__PURE__*/ React.createElement(HeartPulse, null),
            title: labelCockpit,
            tooltipTitle: isNavigationOpen ? "" : labelCockpit
        });
    }
    // FIXME: We are checking for write access to decide if reports are available, but should instead check for read access
    var scheduledReportsAvailable = Feature.inAnyGroup(features)([
        "Reports.ScheduledReport"
    ], "M");
    if (scheduledReportsAvailable) {
        scheduledReports = /*#__PURE__*/ React.createElement(PageLink, {
            href: "/reports",
            icon: /*#__PURE__*/ React.createElement(FileCopy, null),
            title: labelScheduledReports,
            tooltipTitle: isNavigationOpen ? "" : labelScheduledReports
        });
    }
    if (navigationLinks !== undefined && Array.isArray(navigationLinks)) {
        var navLinkRendered = navigationLinks.map(function(row, index) {
            return /*#__PURE__*/ React.createElement(PageLink, {
                key: index,
                href: row.href,
                icon: row.icon,
                title: row.title,
                tooltipTitle: isNavigationOpen ? "" : row.title
            });
        });
        return /*#__PURE__*/ React.createElement(Drawer, {
            variant: "permanent",
            classes: {
                paper: clsx(classes.drawerPaper, !isNavigationOpen && removeNavigation && classes.minimizePaper, !isNavigationOpen && classes.drawerPaperClose, isNavigationOpen && classes.drawerPaperOpen)
            },
            open: isNavigationOpen,
            onTransitionEnd: onTransitionEnd
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.drawerInner
        }, /*#__PURE__*/ React.createElement("div", {
            className: "".concat(classes.topSticky, " ").concat(classes.fullWidth)
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.drawerHeader
        }, /*#__PURE__*/ React.createElement(Hidden, {
            mdUp: true
        }, /*#__PURE__*/ React.createElement(UserInfo, {
            backgroundTone: "light"
        })), /*#__PURE__*/ React.createElement(IconButton, {
            onClick: closeNavigation
        }, /*#__PURE__*/ React.createElement(ChevronLeft, null))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(List, {
            onClick: closeWhileSmall
        }, navLinkRendered)), /*#__PURE__*/ React.createElement("div", {
            className: clsx(classes.bottomSticky, classes.fullWidth)
        }, /*#__PURE__*/ React.createElement(List, {
            onClick: closeWhileSmall
        }, /*#__PURE__*/ React.createElement(PageLink, {
            href: "/auth/logout",
            prefetch: false,
            icon: /*#__PURE__*/ React.createElement(ExitToApp, {
                className: classes.flipIconHorizontal
            }),
            title: labelLogout,
            tooltipTitle: isNavigationOpen ? "" : labelLogout
        })))));
    } else {
        return /*#__PURE__*/ React.createElement(Drawer, {
            variant: "permanent",
            classes: {
                paper: clsx(classes.drawerPaper, !isNavigationOpen && removeNavigation && classes.minimizePaper, !isNavigationOpen && classes.drawerPaperClose, isNavigationOpen && classes.drawerPaperOpen)
            },
            open: isNavigationOpen,
            onTransitionEnd: onTransitionEnd
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.drawerInner
        }, /*#__PURE__*/ React.createElement("div", {
            className: clsx(classes.topSticky, classes.fullWidth)
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.drawerHeader
        }, /*#__PURE__*/ React.createElement(Hidden, {
            mdUp: true
        }, /*#__PURE__*/ React.createElement(UserInfo, {
            backgroundTone: "light"
        })), /*#__PURE__*/ React.createElement(IconButton, {
            onClick: closeNavigation
        }, /*#__PURE__*/ React.createElement(ChevronLeft, null))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(List, {
            onClick: closeWhileSmall
        }, /*#__PURE__*/ React.createElement(PageLink, {
            href: "/",
            icon: /*#__PURE__*/ React.createElement(VectorPolyline, null),
            title: labelLines,
            tooltipTitle: isNavigationOpen ? "" : labelLines
        }), /*#__PURE__*/ React.createElement(PageLink, {
            href: "/sensors",
            icon: /*#__PURE__*/ React.createElement(AccessPointNetwork, null),
            title: labelSensors,
            tooltipTitle: isNavigationOpen ? "" : labelSensors
        }), /*#__PURE__*/ React.createElement(PageLink, {
            href: "/consolidated-lines",
            icon: /*#__PURE__*/ React.createElement(GroupWork, null),
            title: labelConsolidatedLines,
            tooltipTitle: isNavigationOpen ? "" : labelConsolidatedLines
        }), /*#__PURE__*/ React.createElement(PageLink, {
            href: "/andon",
            icon: /*#__PURE__*/ React.createElement(RingVolume, null),
            title: labelMaintenance,
            tooltipTitle: isNavigationOpen ? "" : labelMaintenance
        }), scheduledReports, cockpit)), /*#__PURE__*/ React.createElement("div", {
            className: clsx(classes.bottomSticky, classes.fullWidth)
        }, /*#__PURE__*/ React.createElement(List, {
            onClick: closeWhileSmall
        }, administration, /*#__PURE__*/ React.createElement(PageLink, {
            href: "/feedback",
            icon: /*#__PURE__*/ React.createElement(Feedback, null),
            title: labelFeedback,
            tooltipTitle: isNavigationOpen ? "" : labelFeedback
        }), /*#__PURE__*/ React.createElement(PageLink, {
            href: "/auth/logout",
            prefetch: false,
            icon: /*#__PURE__*/ React.createElement(ExitToApp, {
                className: classes.flipIconHorizontal
            }),
            title: labelLogout,
            tooltipTitle: isNavigationOpen ? "" : labelLogout
        })))));
    }
};
export default Navigation;
